import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
import { VariantTheme } from '@helpers/themeEnums';
import { withMotion } from '@hoc/withMotion';
import SocialMediaLinks from '@stories/Components/SocialMediaLinks/SocialMediaLinks';
import * as React from 'react';
import S from './Footer.styles';
import { useEffect, useRef, useState } from 'react';
import { useResize } from '@hooks/useResize';
const Footer = ({ affiliateLogos, callUs, legalLinks, legalText, linkSections, logo, site, socialMediaLinks, sraLogo, supportingImage, translations, usefulLinksHeading, }) => {
    const [open, setOpen] = useState(-1);
    const [heights, setHeights] = useState({});
    const refs = useRef({});
    const currentYear = new Date().getFullYear(); // returns the current year
    const initHeights = () => {
        const newHeights = {};
        linkSections.forEach((_, i) => {
            const ref = refs.current[i];
            if (ref) {
                newHeights[i] = ref.scrollHeight;
            }
        });
        legalLinks &&
            (newHeights[linkSections.length] = refs.current[linkSections.length]?.scrollHeight || 0);
        setHeights(newHeights);
    };
    useEffect(() => {
        initHeights();
    }, [linkSections]);
    useResize({
        callback: initHeights,
        debounce: 100,
        immediate: true,
        on: 'x',
    });
    useEffect(() => {
        const newHeights = {};
        linkSections.forEach((_, i) => {
            const ref = refs.current[i];
            if (ref) {
                newHeights[i] = ref.scrollHeight;
            }
        });
        setHeights(newHeights);
    }, []);
    return (React.createElement(S.Footer, null,
        React.createElement(S.TopBorder, null),
        React.createElement(S.Container, { variantTheme: VariantTheme.Black },
            React.createElement(S.UpperFooter, null,
                React.createElement(S.UpperFooterLeft, null,
                    React.createElement(S.UpperFooterLeftContent, null,
                        React.createElement(S.LogoWrapper, { href: site.url, target: "_self", "aria-label": site.label },
                            React.createElement(S.Logo, { src: logo.src, alt: logo.altText, loading: "lazy" })),
                        React.createElement(S.CallUs, null,
                            React.createElement(S.CallUsLabel, null, callUs.label),
                            React.createElement(S.CallUsLink, { href: `tel:${callUs.number}`, target: "_blank" },
                                getSvgFromSystem(SystemIcon.Call),
                                React.createElement(S.CallUsNumber, null, callUs.number))),
                        socialMediaLinks && (React.createElement(S.SocialMediaLinksWrapper, null,
                            React.createElement(SocialMediaLinks, { ...socialMediaLinks })))),
                    supportingImage && (React.createElement(S.SupportingImageWrapper, null,
                        React.createElement(S.SupportingImage, { src: supportingImage.src, alt: supportingImage.altText, loading: "lazy" })))),
                React.createElement(S.UpperFooterRight, null,
                    usefulLinksHeading && (React.createElement(S.UsefulLinksHeading, null, usefulLinksHeading)),
                    linkSections && linkSections.length > 0 ? (React.createElement(S.LinkListContainer, null,
                        linkSections.map((group, i) => (React.createElement(S.LinkListGroup, { key: `footer-links-${i}` },
                            React.createElement(S.LinkListHeader, { "data-open": open === i, onClick: () => {
                                    if (open === i) {
                                        setOpen(-1);
                                    }
                                    else {
                                        setOpen(i);
                                    }
                                }, "aria-controls": `footer-links-${i}` },
                                React.createElement("h2", null, group.label.text),
                                getSvgFromSystem(SystemIcon.ChevronDown)),
                            React.createElement(S.LinkList, { id: `footer-links-${i}`, ref: (el) => (refs.current[i] = el), variants: {
                                    initial: {
                                        height: 0,
                                        overflow: 'hidden',
                                    },
                                    open: {
                                        // IOS Fix (Can't animate form 0 to auto)
                                        height: heights[i] || 0,
                                        transitionEnd: {
                                            overflow: 'auto',
                                        },
                                    },
                                }, animate: open === i ? 'open' : 'initial' },
                                group.label.url && (React.createElement("li", { "data-mobile-only": true },
                                    React.createElement("a", { href: group.label.url, target: group.label.target }, group.label.text))),
                                group.links.map((link, j) => (React.createElement("li", { key: `footer-links-${i}-${j}` },
                                    React.createElement("a", { href: link.url, target: link.target },
                                        link.text,
                                        React.createElement("div", { "data-mobile-only": true }, getSvgFromSystem(SystemIcon.ArrowRight)),
                                        React.createElement("div", { "data-desktop-only": true }, getSvgFromSystem(SystemIcon.ChevronRight)))))))))),
                        legalLinks && (React.createElement(S.LinkListGroup, { key: `footer-links-legal`, "data-mobile-only": true },
                            React.createElement(S.LinkListHeader, { "data-open": open === linkSections.length, onClick: () => {
                                    if (open === linkSections.length) {
                                        setOpen(-1);
                                    }
                                    else {
                                        setOpen(linkSections.length);
                                    }
                                }, "aria-controls": `footer-links-${linkSections.length}` },
                                React.createElement("h2", null, legalLinks.label.text),
                                getSvgFromSystem(SystemIcon.ChevronDown)),
                            React.createElement(S.LinkList, { id: `footer-links-${linkSections.length}`, ref: (el) => (refs.current[linkSections.length] = el), variants: {
                                    initial: {
                                        height: 0,
                                        overflow: 'hidden',
                                    },
                                    open: {
                                        // IOS Fix (Can't animate form 0 to auto)
                                        height: heights[linkSections.length] || 0,
                                        transitionEnd: {
                                            overflow: 'auto',
                                        },
                                    },
                                }, animate: open === linkSections.length ? 'open' : 'initial' }, legalLinks.links.map((link, j) => (React.createElement("li", { key: `footer-links-legal-${j}`, "data-mobile-only": true },
                                React.createElement("a", { href: link.url, target: link.target },
                                    link.text,
                                    React.createElement("div", { "data-mobile-only": true }, getSvgFromSystem(SystemIcon.ArrowRight)),
                                    React.createElement("div", { "data-desktop-only": true }, getSvgFromSystem(SystemIcon.ChevronRight))))))))))) : null)),
            React.createElement(S.LowerFooter, null,
                React.createElement(S.LowerFooterLeft, null,
                    React.createElement(S.LegalTextBody, { dangerouslySetInnerHTML: { __html: legalText.body } }),
                    React.createElement(S.CopyrightText, null,
                        React.createElement("p", null,
                            React.createElement("b", null,
                                "\u00A9 ",
                                currentYear,
                                " | ",
                                legalText.companyName),
                            legalText.sraId ? React.createElement("b", null,
                                " |",
                                ' ',
                                " ",
                                translations['global.site.sraLabel'],
                                ":") : '',
                            legalText.sraId))),
                React.createElement(S.LowerFooterRight, null,
                    affiliateLogos && (React.createElement(S.AffiliateLogos, null,
                        affiliateLogos.map((logo, index) => (React.createElement("div", { key: `affiliate-logo-${index}` },
                            React.createElement(S.AffiliateLogo, { src: logo.src, alt: logo.altText ?? '' })))),
                        sraLogo && (React.createElement("div", null,
                            React.createElement(S.SRALogo, { src: sraLogo.src, alt: sraLogo.altText ?? '' }))))),
                    legalLinks && (React.createElement(S.LegalLinks, null, legalLinks.links.map((link, index) => (React.createElement("li", { key: `legal-link-${index}` },
                        React.createElement(S.LegalLink, { key: `legal-link-${index}`, href: link.url, target: link.target ?? '_self' }, link.text))))))),
                React.createElement(S.LowerFooterMobile, null,
                    socialMediaLinks && (React.createElement(S.SocialMediaLinksWrapper, null,
                        React.createElement(SocialMediaLinks, { ...socialMediaLinks }))),
                    sraLogo && (React.createElement("div", null,
                        React.createElement(S.SRALogo, { src: sraLogo.src, alt: sraLogo.altText ?? '' }))))))));
};
export default withMotion(Footer);
